import React from "react";
import { Checkbox, Flex, Text } from "@appsmith/ads";
import styled, { css } from "styled-components";

interface ToolCheckBoxProps {
  children?: React.ReactNode;
  isEditing: boolean;
  isSelected: boolean;
  label: string;
  onClick: () => void;
}

const CheckboxContainer = styled(Flex)<{ isActive: boolean }>`
  padding: var(--ads-v2-spaces-2) var(--ads-v2-spaces-4);
  height: 32px;
  align-items: center;
  justify-content: space-between;
  &:hover {
    background-color: var(--ads-v2-color-bg-subtle);
  }
  ${({ isActive }) =>
    isActive &&
    css`
      background-color: var(--ads-v2-color-bg-subtle);
    `}

  /**
   * Align the checkbox with the text
   */
  && .ads-v2-checkbox__square {
    top: 1px;
  }

  /**
   * Edit icon is visible on hover and when active
   */
  && .tool-edit-controls {
    visibility: hidden;
    & label {
      width: unset;
    }
  }
  &:hover {
    && .tool-edit-controls {
      visibility: visible;
    }
  }
  ${({ isActive }) =>
    isActive &&
    css`
      && .tool-edit-controls {
        visibility: visible;
      }
    `}
`;

export const ToolCheckBox = (props: ToolCheckBoxProps) => {
  const { isEditing, isSelected, label, onClick } = props;

  return (
    <CheckboxContainer isActive={isEditing}>
      <Checkbox isSelected={isSelected} onChange={onClick}>
        <Text kind="action-m">{label}</Text>
      </Checkbox>
      {props.children}
    </CheckboxContainer>
  );
};
